/**
 * @module common/mixins/controller-mutations
 */

/**
 * @classdesc Мутации для контроллера
 */
class ControllerMutations {
  constructor(state) {
    const mutable = state;

    /**
     * @method
     * @description Устанавливает состояние запроса в PENDING
     * @param {String} actionName - Имя метода в контроллере
     */
    this.SET_ACTION_STATUS_PENDING = (actionName) => {
      mutable[actionName].status.isPending = true;
      mutable[actionName].status.isFailed = false;
      mutable[actionName].status.isSucceeded = false;
    };

    /**
     * @method
     * @description Устанавливает состояние запроса в FAILED
     * @param {String} actionName - Имя метода в контроллере
     */
    this.SET_ACTION_STATUS_FAILED = (actionName) => {
      mutable[actionName].status.isPending = false;
      mutable[actionName].status.isFailed = true;
      mutable[actionName].status.isSucceeded = false;
    };

    /**
     * @method
     * @description Устанавливает состояние запроса в SUCCEEDED
     * @param {String} actionName - Имя метода в контроллере
     */
    this.SET_ACTION_STATUS_SUCCEEDED = (actionName) => {
      mutable[actionName].status.isPending = false;
      mutable[actionName].status.isFailed = false;
      mutable[actionName].status.isSucceeded = true;
    };

    /**
     * @method
     * @description Сбрасывает состояние запроса к изначальному
     * @param {String} actionName - Имя метода в контроллере
     */
    this.RESET_ACTION_STATUS = (actionName) => {
      mutable[actionName].status.isPending = false;
      mutable[actionName].status.isFailed = false;
      mutable[actionName].status.isSucceeded = false;
    };
  }
}

/**
 * @method
 * @description Генерирует мутации для состояния контроллера
 * @param {Object} state - состояние контроллера
 */
function generateMutations(state) {
  const mutations = new ControllerMutations(state);
  return mutations;
}

/**
 * @mixin
 */
const controllerMutations = state => generateMutations(state);

export default controllerMutations;
